import { useQuery } from 'react-query'

import { useLogger } from '@vp/ubik-context'

import { getBreadcrumbs } from '../../../../clients/BreadcrumbClient'
import type { Breadcrumb } from '../../../../types/Breadcrumbs'
import { useAppState } from '../../../root/contexts/AppContext'
import { useProject } from '../../../root/contexts/ProjectContext'
import { useTenant } from '../../../root/contexts/TenantContext'

/**
 *  Hook used to retrieve the recommended category from the
 * breadcrumbs based on the current projects MPV ID.
 */
export const useRecommendedCategory = () => {
  const { culture } = useAppState()
  const { mpvId } = useProject()
  const { tenant } = useTenant()
  const logger = useLogger()

  const { data: recommendedCategory, isFetched } = useQuery(
    ['recommended-category', tenant],
    async (): Promise<Breadcrumb | undefined> => {
      try {
        const breadcrumbs = await getBreadcrumbs(tenant, culture, mpvId, logger)
        if (breadcrumbs && breadcrumbs.length >= 2) {
          return breadcrumbs[breadcrumbs.length - 2]
        }
      } catch {
        // Optionally log error here
      }
      return undefined
    },
    { enabled: !!culture, staleTime: Infinity },
  )

  return {
    recommendedCategory,
    recommendedCategoryIsReady: isFetched,
  }
}
